<template>
    <v-container>
        <v-row align="center" justify="center">
            <h1>Top 20 Highscores</h1>
        </v-row>
        <v-row align="center" justify="center">
            <v-simple-table class="table">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left">Place</th>
                        <th class="text-left">Name</th>
                        <th class="text-left">Score</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="highscore in highscores" v-bind:key="highscore['.key']">
                        <td>{{highscores.indexOf(highscore)+1}}</td>
                        <td>{{ highscore.name }}</td>
                        <td>{{ highscore.score }}</td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-row>
    </v-container>
</template>

<script>
    import {highscoresCollection} from "../../firebase";

    export default {
        data() {
            return {
                highscores: [],
            }
        },
        created() {
            highscoresCollection.orderBy('score', 'desc').limit(20).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    this.highscores.push(doc.data())
                });
            });
        }
    }
</script>

<style scoped>
    h1 {
        margin-top: 1em;
    }

    .table {
        width: 90%;
        margin-top: 2em;
    }
</style>